<template>
  <Modal v-model="showModal" class="lost-password-modal" footer-hide width="400px">
    <div class="content">
      <div>
        <p style="margin-bottom:20px;">
          <span class="icon-con">
            <Icon type="md-lock" />
          </span>
          Lost your password?
        </p>
        <p style="margin-bottom:20px;">Please enter your email address and you will receive a link to create a new password via email.</p>
      </div>
      <InfoMessages ref="InfoMessages" type="success" />
      <Form ref="LostPasswordForm" :model="formData" :rules="formRules">
        <formItem label="Email address" prop="email">
          <Input v-model="formData.email" class="k-input" />
        </formItem>
        <formItem>
          <Button class="k-btn-1" long @click="handleForgotPass('LostPasswordForm')" :loading="isLoading">Reset password</Button>
        </formItem>
      </Form>
    </div>
  </Modal>
</template>

<script>
import { forgotPassword } from '@/services/auth'
import InfoMessages from '@/components/ui/InfoMessages'

export default {
  components: {
    InfoMessages
  },

  data () {
    return {
      isLoading: false,
      showModal: false,
      formData: {
        email: ''
      },
      formRules: {
        email: [
          { required: true, message: 'Email cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    openModal () {
      this.$refs.InfoMessages.showErrors()
      this.showModal = true
    },
    handleForgotPass (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.handleReset()
        }
      })
    },
    handleReset () {
      this.isLoading = true
      forgotPassword(this.formData).then(res => {
        this.$refs.InfoMessages.showErrors({
          data: {
            message: 'Reset password request is sent, please check your email message.'
          }
        })
        this.$refs.LostPasswordForm.resetFields()
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to forgot your password: ', err)
        this.isLoading = false
        this.$Message.error({
          background: true,
          duration: 5,
          content: err.response.data.message
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.lost-password-modal {
  .icon-con {
    background: $primary;
    border-radius: 50%;
    padding: 7px 9px;
    font-size: 17px;
    margin-right: 5px;
    color: #ffffff;
  }
}
</style>
